export const IDENTIFIER_SCHEME_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "Internal" },
  { value: "ean", label: "EAN" },
  { value: "sku", label: "SKU" },
  { value: "supplier", label: "Supplier code" },
  { value: "other", label: "Other" },
]
